<template>
    <div class="pa-8">
        <h1>Hello World!</h1>
    </div>
</template>

<script>

export default {
    name: 'NotFoundView',
}
</script>

<style scoped>
h1 {
    color: #42b983;
    font-size: 2em;
    text-align: center;
}

.pa-8 {
    padding: 2rem;
}
</style>